import React from 'react'
import styled from '@emotion/styled'
import {TopBannerSpacer} from 'components/MobileTopAppBanner/Spacer'
import {Web2AppHoldOutWrapper} from 'components/Web2AppHoldOutWrapper'
import {useMobileSearchHeaderHeight} from 'hooks/useMobileSearchHeaderHeight'
// eslint-disable-next-line no-restricted-imports
import getSafeBottomSpacingValue from 'utils/getSafeBottomSpacing'

import {cssTheme} from '@vio/atlas/themes'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {useIsEmbeddedWithBrand} from '@vio/core/src/_web/brand/hooks/useIsEmbeddedWithBrand'
import {isFlutterAppWebView} from '@vio/core/src/native'

export const HEADER_HEIGHT_MOBILE = 65

export const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100vh;
  min-height: stretch;
`

export const HeaderWrapper = styled.div`
  position: relative;
  z-index: 4;
  &.--is-fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }
`

export const MainContentWrapper = styled.section`
  position: relative;
  z-index: 2;
  display: flex;
  flex-flow: column;
  flex: 1;
`

export const FooterWrapper = styled.div<{isSafari: boolean}>`
  padding-bottom: ${cssTheme.layout.spacing.s600};
  padding-bottom: ${({isSafari}) =>
    getSafeBottomSpacingValue({
      spacing: cssTheme.layout.spacing.s600,
      isSafari
    })};

  background: ${cssTheme.colors.background.neutral.primary};
  position: relative;
  z-index: 1;
`

const FixedHeaderSpacer = styled.div<{searchMobileHeaderHeight: number}>`
  height: ${({searchMobileHeaderHeight}) => searchMobileHeaderHeight}px;
`

export const HeaderSpacer = () => {
  const {search, retention} = useBrandCapabilities()
  const isWebView = isFlutterAppWebView()
  const isEmbedded = useIsEmbeddedWithBrand()
  const searchMobileHeaderHeight = useMobileSearchHeaderHeight(
    !search.hasFilters,
    isEmbedded
  )

  return (
    <>
      <Web2AppHoldOutWrapper
        element={<TopBannerSpacer />}
        enabled={!isWebView && retention.hasWeb2App}
        holdOutElement={null}
      />
      <FixedHeaderSpacer searchMobileHeaderHeight={searchMobileHeaderHeight} />
    </>
  )
}
